import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";
import { primary20, PRIMARY_COLOR } from "../../constants/colors";
import { SUBMIT } from "../../constants/constants";

export const StepperView = ({
  steps,
  current,
  prev,
  // next,
  submitting,
  submitText = SUBMIT,
}: {
  steps?: any;
  current?: any;
  prev?: any;
  next?: any;
  submitting?: any;
  submitText?: string;
}) => {
  const [direction, setDirection] = useState("");

  // PREVIOUS
  const prevButton = () => {
    return (
      <div className="flexGrow">
        {current > 0 && (
          <Button
            className="font13 main"
            onClick={() => {
              prev();
              setDirection("right");
            }}
            type="text"
            icon={<ArrowLeftOutlined />}
          >
            Back
          </Button>
        )}
      </div>
    );
  };

  // NEXT
  const nextButton = () => {
    return (
      <>
        {current < steps.length - 1 && (
          <Button
            type="primary"
            htmlType="submit"
            className="font13 noShadow"
            onClick={() => {
              setDirection("left");
            }}
          >
            Next
          </Button>
        )}
      </>
    );
  };

  // DONE
  const submitButton = () => {
    return (
      <>
        {current === steps.length - 1 && (
          <Button
            type="primary"
            className="font13 capitalize"
            htmlType="submit"
            loading={submitting}
          >
            {submitText}
          </Button>
        )}
      </>
    );
  };

  return (
    <>
      {/* STEPS */}
      <div className="flexCenter gap10">
        {steps?.map((_: any, index: number) => {
          const isSelected = current === index;
          return (
            <div
              key={index}
              className="r15"
              style={{
                width: isSelected ? 15 : 8,
                height: 8,
                transition: "all 0.3s",
                backgroundColor: isSelected ? PRIMARY_COLOR : primary20,
              }}
            />
          );
        })}
      </div>

      {/* CONTENT */}
      <div className="flexColumn gap15 radius10 flexGrow">
        <div
          key={current}
          data-aos={`fade-${direction}`}
          data-aos-duration="1000"
        >
          <div>{steps?.[current]?.content}</div>
        </div>
      </div>

      {/* ACTIONS */}
      <div className="flexNullCenter">
        {prevButton()}
        {nextButton()}
        {submitButton()}
      </div>
    </>
  );
};

export function useStepper() {
  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };

  return { next, prev, current };
}
